import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { api, formatApiError } from "../lib/api";

export default function KdsLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") || "/kds";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("kds_token")) navigate(next);
  }, [navigate, next]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("kds_token", data.access_token);
      navigate(next);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-5">
      <form onSubmit={handleLogin} className="w-full max-w-sm border border-neon-green/25 bg-elevated p-8" data-testid="kds-login-form">
        <div className="text-center mb-6">
          <span className="font-heading text-4xl text-neon-green neon-glow-green">67</span>
          <span className="font-heading text-2xl text-neon-yellow ml-2">KITCHEN</span>
          <h1 className="font-heading text-3xl uppercase tracking-wide mt-2 flex items-center justify-center gap-2"><Lock size={22} className="text-neon-green" /> Staff Login</h1>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="font-body text-sm text-neutral-400">Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="kds-email" type="email" className="bg-black border-neon-green/30 text-white mt-1" />
          </div>
          <div>
            <Label className="font-body text-sm text-neutral-400">Password</Label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} data-testid="kds-password" type="password" className="bg-black border-neon-green/30 text-white mt-1" />
          </div>
          {error && <p className="font-body text-sm text-red-400" data-testid="kds-login-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="kds-login-btn" className="w-full font-heading text-xl tracking-wide bg-neon-green text-black hover:bg-neon-yellow py-5">
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Enter Kitchen"}
          </Button>
        </div>
      </form>
    </div>
  );
}
